import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AdminShell from "./AdminShell";
import Field from "./components/Field";
import Button from "./components/Button";
import Stack from "./components/Stack";
import { commentCreate } from "./api";

export default function AdminComment() {
  const history = useHistory();
  const [description, setDescription] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!description) {
      toast.error("Please write a comment.");
      return;
    }
    try {
      await commentCreate({
        sp_id: localStorage.getItem("adminuid"),
        timestamp: Date.now(),
        description,
      });
      toast.success("Comment added.");
      history.push("/adminviewcomments");
    } catch (error) {
      console.log(error);
      toast.error("Comment unsuccessful. Try again.");
    }
  };

  return (
    <AdminShell title="Add a comment">
      <form onSubmit={onSubmit} style={{ maxWidth: 560 }}>
        <Stack gap="5">
          <Field
            id="description"
            label="Comment for user"
            textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Write your comment here"
            required
          />
          <Button type="submit">Add comment</Button>
        </Stack>
      </form>
    </AdminShell>
  );
}
